if (!customElements.get('adev-featured-cards')) {
    customElements.define('adev-featured-cards', class adevFeaturedCards extends HTMLElement {
        
        constructor() {
            super();

            this.carouselEl = this.querySelector('[data-adev-featured-cards="carousel"]');
            this.carouselPrevButton = this.querySelector('[data-adev-featured-cards="carousel-prev"]');
            this.carouselNextButton = this.querySelector('[data-adev-featured-cards="carousel-next"]');
        }
        
        getlCellAlign() {
            return 'left';
        }

        getInitialIndex () {
            return 0;
        }
        
        initCarousel(){
            if (!this.carouselEl) return;

            let settings = {
                cellAlign: this.getlCellAlign(),
                contain: false,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: false,
                initialIndex: this.getInitialIndex(),
                adaptiveHeight: false,
                on: {
                    ready: () => {
                        this.carouselEl.classList.add('adev--flickity-ready');
                    },
                    settle: () => {
                        this.carouselEl.classList.add('adev--flickity-ready');
                        this.carouselEl.classList.remove('adev--flickity-moving');
                    },
                    dragStart: () => {
                        this.carouselEl.classList.add('adev--flickity-moving');
                    },
                    dragEnd: () => {
                        this.carouselEl.classList.remove('adev--flickity-moving');
                    },
                    change: () => {
                        
                    },
                    select: () => {
                        
                    }
                }
            };

            this.carouselInstance = new Flickity(this.carouselEl, settings);

            this.initArrows();
        }

        goPrev(){
            if(this.carouselEl){
                const prevOne = this.carouselEl.querySelector('.is--active');
                let prevIndex = parseInt(prevOne.dataset.index);

                const isDesktop = window.matchMedia('(min-width: 992px)').matches;
                const columnsPerView = isDesktop ? 4 : 2;
                const isLastThree = prevIndex >= this.carouselEl.children.length - 3;
                const isLastTwo = prevIndex >= this.carouselEl.children.length - 2;

                let index = prevIndex - 1;
                if(isDesktop && isLastThree){
                    index = this.carouselEl.children.length - columnsPerView - 1;
                } else if(!isDesktop && isLastTwo){
                    index = this.carouselEl.children.length - columnsPerView - 1;
                }
                
                const newActive = this.carouselEl.querySelector(`[data-index="${index}"]`);
                if(newActive){
                    prevOne.classList.remove('is--active');
                    newActive.classList.add('is--active');
                    
                    this.carouselEl.scrollTo({ 
                        left: newActive.offsetLeft,
                        behavior: 'smooth' 
                    });
                }
            }
        }

        goNext(){
            if(this.carouselEl){
                const prevOne = this.carouselEl.querySelector('.is--active');
                let prevIndex = parseInt(prevOne.dataset.index);

                const newActive = this.carouselEl.querySelector(`[data-index="${prevIndex + 1}"]`);
                if(newActive){
                    prevOne.classList.remove('is--active');
                    newActive.classList.add('is--active');
                    
                    this.carouselEl.scrollTo({ 
                        left: newActive.offsetLeft,
                        behavior: 'smooth' 
                    });
                }

            }
        }

        initArrows() {
            if (this.carouselPrevButton) {
                this.carouselPrevButton.addEventListener('click', this.goPrev.bind(this));
            }

            if (this.carouselNextButton) {
                this.carouselNextButton.addEventListener('click', this.goNext.bind(this));
            }
        }

        destroyArrows() {
            if (this.carouselPrevButton) {
                this.carouselPrevButton.removeEventListener('click', this.goPrev.bind(this));
            }

            if (this.carouselNextButton) {
                this.carouselNextButton.removeEventListener('click', this.goNext.bind(this));
            }
        }

        destroyCarousel(){
            if(this.carouselInstance){
                this.carouselInstance.destroy();
            }

            this.destroyArrows();
        }

        onViewportChange(e) {
            if (e.matches) {
                this.initCarousel();
            } else {
                this.destroyCarousel();
            }
        }
        
        connectedCallback() {
            this.initArrows();
            // const isDesktop = window.matchMedia('(min-width: 992px)').matches;

            // if (isDesktop) {
            //     this.initCarousel();
            // }
            
            // window.matchMedia('(min-width: 992px)').addEventListener('change', this.onViewportChange.bind(this));
        }

        disconnectedCallback() {
            this.destroyArrows();
            // this.destroyCarousel();
            // window.matchMedia('(min-width: 992px)').removeEventListener('change', this.onViewportChange.bind(this));
        }

    });
}